import request from '@/plugin/axios'

export function AccountLogin (data) {
  return request({
    url: '/sys/login',
    method: 'post',
    data
  })
}

export function AccountCaptcha (data) {
  return process.env.VUE_APP_API + '/captcha.jpg?uuid=' + data
}

export function ChangePwdCheck (data) {
  return request({
    url: '/sys/changePwdCheck',
    method: 'post',
    data
  })
}

export function ChangePwdByMobile (data) {
  return request({
    url: '/sys/user/changePwdByMobile',
    method: 'post',
    data: request.adornData(data)
  })
}

// 获取短信验证码
export function GetPhoneCode (data, tempToken) {
  return request({
    url: '/airsense/api/mobile/code?token=' + tempToken,
    method: 'get',
    params: request.adornParams(data)
  })
}
